import React from "react";
import Styles from './styles.module.scss';


const PublicFooter = () => {

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.gradientBorder}`}/>
            <div className={`${Styles.contentWrap}`}>
                F#ck the Fomo
            </div>
        </section>
    );
};

export default PublicFooter;
